export const header_by = {
    main: "Галоўная",
    logIn: "Увайсці",
    logOut: "Выйсці",
    exhibition: "Выстаўка",
    participans: "Удзел",
    info: 'Інфармацыя',
    blog: "Навіны",
    account: 'Асабісты кабінет'
}